import type { CampaignStatus } from '@atlas/contracts';

/**
 * A query-kulcsok. A lapnak EGY nézete van (idősáv), és az a látható ABLAKRA tölt — a kulcs ezért az
 * ablakból (`from`/`to`) képződik, a szűrők pedig a hívó oldalán egészítik ki. Az `all` az invalidálás
 * gyökere: egy írás után a nyitott ablak(ok) mindegyike frissül.
 */
export const campaignKeys = {
  all: ['campaign-forecast'] as const,
  timeline: (window: { from: string; to: string }) =>
    ['campaign-forecast', 'timeline', window] as const,
  detail: (id: string) => ['campaign-forecast', 'detail', id] as const,
  /** A `lang` a kulcs RÉSZE: a személy-nevek sorrendje nyelvfüggő, a válasz pedig cache-elve szolgál ki. */
  refs: (lang: string) => ['campaign-forecast', 'refs', lang] as const,
};

/** A státusz-szűrő megjelenítési sorrendje (az értékkészlet forrása a contract). */
export const CAMPAIGN_STATUSES: readonly CampaignStatus[] = ['planned', 'running', 'closed'];
